import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { MainOperatorRestrictionData } from "../../config/tableConfigs";
import MainOperatorRestrictionFormModal from "./components/MainOperatorRestrictionFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";
import { showMainToast } from "utils/showToast";

const MainOperatorRestrictionPage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/main_operator_action",
    MainOperatorRestrictionData,
    formdata,
    refresh
  );

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteMainOperatorRestriction");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  // ✅ Toggle is_active via TOGGLE action — no modal needed
  const handleToggle = async (row) => {
    try {
      const form = new FormData();
      form.append("action", "TOGGLE");
      form.append("id",     row.id);
      form.append("userid", userid);

      const res    = await fetch("https://pro.mokshiq.in/main_operator_action", {
        method : "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        body   : form,
      });
      const result = await res.json();

      if (result.status) {
        showMainToast(result.data, "success");
        setRefresh((prev) => prev + 1); // re-fetch table
      } else {
        showMainToast(result.data || "Toggle failed!", "danger");
      }
    } catch {
      showMainToast("Something went wrong!", "danger");
    }
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting:", selectedIds);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <main>
      <div className="container-fluid">
        {/* Custom Header Layout */}
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Main Operator Restriction</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-list-dashes f-s-16"></i> <span className="ms-1">Main Operator</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Restriction
                </a>
              </div>
            </div>

            <div>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center px-4"
                onClick={handleAddUser}
                style={{
                  backgroundColor: "#7e57c2", borderColor: "#7e57c2", borderRadius: "8px", height: "44px", width: "fit-content", minWidth: "160px"
                }}
              >
                <i className="iconoir-plus-circle me-2" style={{ fontSize: "20px" }}></i>
                <span className="fw-medium text-nowrap">Add</span>
              </button>
            </div>
          </div>
        </div>

        {/* Card Body */}
        <div className="row m-1">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <DataTable
                  config={MainOperatorRestrictionData}
                  tableData={tableData}
                  onView={undefined}          // no view needed
                  onEdit={handleEditUser}
                  onDelete={handleDelete}
                  onToggle={handleToggle}     
                  onExport={handleExport}
                  onDeleteSelected={handleDeleteSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <MainOperatorRestrictionFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deleteMainOperatorRestriction"
        title="Delete Operator Restriction"
        message="Are you sure you want to delete this restriction?"
        apiUrl="https://pro.mokshiq.in/main_operator_action"
        onSuccess={handleDeleteSuccess}
      />
    </main>
  );
};

export default MainOperatorRestrictionPage;